'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Locations = function (_Resource) {
    (0, _inherits3.default)(Locations, _Resource);

    function Locations() {
        (0, _classCallCheck3.default)(this, Locations);
        return (0, _possibleConstructorReturn3.default)(this, (Locations.__proto__ || (0, _getPrototypeOf2.default)(Locations)).apply(this, arguments));
    }

    (0, _createClass3.default)(Locations, [{
        key: 'getAll',

        /**
         * @api {get} /v1/locations getAll
         * @apiGroup Locations
         * @apiName getAll
         * @apiDescription Return all locations of the current customer's organization. Capable of returning paginated results.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locations.getAll({...})
         */
        value: function getAll(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/locations' + query);
        }

        /**
         * @api {post} /v1/locations bulkCreate
         * @apiGroup Locations
         * @apiName bulkCreate
         * @apiDescription Create new locations with the current user's organization. Currently does not check permissions.
         * @apiParam {Object[]} locations
         * @apiExample {js} Example:
         *             gigwalk.locations.bulkCreate({...})
         */

    }, {
        key: 'bulkCreate',
        value: function bulkCreate(params) {
            var data = {
                locations: params.locations
            };

            return this.client.post('/v1/locations', data);
        }

        /**
         * @api {get} /v1/locations/:location_id get
         * @apiGroup Locations
         * @apiName get
         * @apiDescription Return information about specified location. Capable of returning paginated results.
         * @apiParam {Number} location_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locations.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/locations/' + params.location_id + query);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/locations getAllForOrganization
         * @apiGroup Locations
         * @apiName getAllForOrganization
         * @apiDescription Return all locations of the specified organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.locations.getAllForOrganization({...})
         */

    }, {
        key: 'getAllForOrganization',
        value: function getAllForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/locations' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/locations bulkCreateForOrganization
         * @apiGroup Locations
         * @apiName bulkCreateForOrganization
         * @apiDescription Create new location(s) in organization. Currently does not check permissions.
         * @apiParam {Number} organization_id
         * @apiParam {Object[]} locations
         * @apiExample {js} Example:
         *             gigwalk.locations.bulkCreateForOrganization({...})
         */

    }, {
        key: 'bulkCreateForOrganization',
        value: function bulkCreateForOrganization(params) {
            var data = {
                locations: params.locations
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/locations', data);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/locations bulkUpdateForOrganization
         * @apiGroup Locations
         * @apiName bulkUpdateForOrganization
         * @apiDescription Update locations of the specified organization. Currently does not check permissions.
         * @apiParam {Number} organization_id
         * @apiParam {Object[]} locations
         * @apiExample {js} Example:
         *             gigwalk.locations.bulkUpdateForOrganization({...})
         */

    }, {
        key: 'bulkUpdateForOrganization',
        value: function bulkUpdateForOrganization(params) {
            var data = {
                locations: params.locations
            };

            return this.client.put('/v1/organizations/' + params.organization_id + '/locations', data);
        }

        /**
         * @api {delete} /v1/organizations/:organization_id/locations/:location_id deleteForOrganization
         * @apiGroup Locations
         * @apiName deleteForOrganization
         * @apiDescription Delete location. Only metadata is deleted. Currently does not check permissions.
         * @apiParam {Number} organization_id
         * @apiParam {Number} location_id
         * @apiExample {js} Example:
         *             gigwalk.locations.deleteForOrganization({...})
         */

    }, {
        key: 'deleteForOrganization',
        value: function deleteForOrganization(params) {
            return this.client.delete('/v1/organizations/' + params.organization_id + '/locations/' + params.location_id);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/locations/:location_id getForOrganization
         * @apiGroup Locations
         * @apiName getForOrganization
         * @apiDescription Return information about the given location. Location should belong to the organization.
        * @apiParam {Number} organization_id
        * @apiParam {Number} location_id
         * @apiExample {js} Example:
         *             gigwalk.locations.getForOrganization({...})
         */

    }, {
        key: 'getForOrganization',
        value: function getForOrganization(params) {
            return this.client.get('/v1/organizations/' + params.organization_id + '/locations/' + params.location_id);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/locations/geocode createForOrganization
         * @apiGroup Locations
         * @apiName createForOrganization
         * @apiDescription Adds metadata items to organization location metadata, as well as creates a new location with address and title.
         * @apiParam {Number} organization_id
         * @apiParam {String} title
         * @apiParam {String} address
         * @apiParam {Object} [organization_data]
         * @apiExample {js} Example:
         *             gigwalk.locations.createForOrganization({...})
         */

    }, {
        key: 'createForOrganization',
        value: function createForOrganization(params) {
            var data = {
                address: params.address,
                title: params.title,
                organization_data: params.organization_data,
                override_existing: params.override_existing
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/locations/geocode', data);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/locations/geocode/:location_id updateForOrganization
         * @apiGroup Locations
         * @apiName updateForOrganization
         * @apiDescription Adds metadata items to organization location metadata, as well as creates a new location with address and title.
         * @apiParam {Number} organization_id
         * @apiParam {Number} location_id
         * @apiParam {String} title
         * @apiParam {String} address
         * @apiParam {Object} [organization_data]
         * @apiExample {js} Example:
         *             gigwalk.locations.updateForOrganization({...})
         */

    }, {
        key: 'updateForOrganization',
        value: function updateForOrganization(params) {
            var data = {
                address: params.address,
                title: params.title,
                organization_data: params.organization_data ? params.organization_data : []
            };

            return this.client.put('/v1/organizations/' + params.organization_id + '/locations/geocode/' + params.location_id, data);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/subscriptions/:subscription_id/locations createListForOrganization
         * @apiGroup Locations
         * @apiName createListForOrganization
         * @apiDescription If a project doesn't have an ad-hoc location list, a new list is created and assigned to the project.
                           The new location is then added to the list.
         * @apiParam {Number} organization_id
         * @apiParam {Number} subscription_id
         * @apiExample {js} Example:
         *             gigwalk.locations.createListForOrganization({...})
         */

    }, {
        key: 'createListForOrganization',
        value: function createListForOrganization(params) {
            return this.client.post('/v1/organizations/' + params.organization_id + '/subscriptions/' + params.subscription_id + '/locations');
        }
    }]);
    return Locations;
}(_resource2.default);

exports.default = Locations;
//# sourceMappingURL=index.js.map